import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import 'element-ui/lib/theme-chalk/index.css'
import {DatePicker,Radio,RadioGroup,Drawer,Popconfirm,Tabs,TabPane,Autocomplete,Upload,Dropdown,Avatar,DropdownMenu, DropdownItem, Dialog, Message,Button, Card, Table, TableColumn, Form, FormItem, Select, Option, Input,Checkbox,Pagination,Descriptions,DescriptionsItem } from 'element-ui'

// axios的配置
axios.defaults.baseURL = 'http://1.14.14.218:9091/'
Vue.prototype.$http = axios
Vue.prototype.$message = Message

Vue.config.productionTip = false


Vue.use(DatePicker)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Drawer)
Vue.use(Popconfirm)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Button)
Vue.use(Card)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(Pagination)
Vue.use(Descriptions)
Vue.use(DescriptionsItem)
Vue.use(Upload)
Vue.use(Dialog)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(Avatar)
Vue.use(DropdownMenu)
Vue.use(Autocomplete)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
